module.exports = __webpack_public_path__ + "media/assets/images/blog/controller_switches-small-5420fb2d2c022130552ab75c44b88e1e.jpg";